import styled from 'styled-components'
import tw from 'twin.macro'
import ProgressBar from 'components/Common/ProgressBar'

export const Container = styled.div`
  ${tw`bg-white rounded-2xl border border-background-hover`}
  ${tw`px-4 pt-4 pb-6 sm:px-6 sm:pt-5 sm:pb-8 md:px-8 md:pt-6 md:pb-10`}
  ${tw`flex flex-col sm:flex-row gap-4`}
  box-shadow: 0px 16px 32px -16px #00000014, 0px 12px 24px -12px #0000001F;
`
export const AvatarColumn = styled.div`
  ${tw`flex items-start justify-center sm:justify-start flex-shrink-0`}
  width: 64px;
`

export const InfoColumn = styled.div`
  ${tw`flex flex-col flex-1 `}
  ${tw`sm:ml-4`}
  min-width: 0;
`

export const TitleRow = styled.div`
  ${tw`flex justify-between items-center`}
`
export const Title = styled.h1`
  ${tw`text-lg sm:text-xl lg:text-2xl font-medium font-inter`}
  word-break: break-word;
  overflow-wrap: break-word;
`

export const Description = styled.p`
  ${tw`text-sm font-normal leading-5 text-primary-disabledTextLight`}
`

export const ProgressContainer = styled.div`
  ${tw` mt-2`}
`

export const ProgressText = styled.p`
  ${tw`text-right text-sm font-normal text-primary-disabledTextLight`}
`

export const StyledProgressBar = styled(ProgressBar)`
  ${tw`bg-primary-appBrand rounded-s-3xl !rounded-e-none`}
`
